import { GuestType } from 'src/api/api.generated'

export function isGuarantor(guestType: GuestType | null | undefined): boolean {
  return [GuestType.GROUP_HEAD, GuestType.HEAD_OF_FAMILY, GuestType.SINGLE_GUEST].some((gt) => gt === guestType)
}
